export default "__VITE_ASSET__BSrADxXR__"